import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { EidAuthService } from '../services/eid-auth.service';
import { EidSessionService } from '../services/eid-session.service';
import { CustomToastersService, RedirectService, RouteHelperService } from '@app/shared/services';
import { AuthService } from '@app/api/api-services/auth.service';
import { EidErrors } from '../enums/eid-errors.enum';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-eid-logged-in',
  templateUrl: './eid-logged-in.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EidLoggedInComponent implements OnInit, OnDestroy {
  private readonly subscriptions = new Subscription();

  constructor(
    private readonly eidAuthService: EidAuthService,
    private readonly eidSessionService: EidSessionService,
    private readonly authService: AuthService,
    private readonly redirectService: RedirectService,
    private readonly customToasters: CustomToastersService,
    private readonly routeHelper: RouteHelperService
  ) {}

  ngOnInit() {
    if (this.authService.isAuthenticated()) {
      this.redirectService.redirectToDefault();
    }
    this.subscriptions.add(
      this.eidAuthService.isAuthenticated.subscribe(
        (authenticated) => {
          if (authenticated) {
            const idTokenSubscription = this.eidAuthService.idToken.subscribe(
              (idToken) => {
                if (idToken) {
                  this.exchangeToken(idToken);
                } else {
                  this.customToasters.customError(EidErrors.noCodeOrToken);
                  this.routeHelper.login(true);
                }
              },
              (error) => {
                this.customToasters.customError(EidErrors.errorRetrievingIdToken + ' : ' + error);
                this.routeHelper.login(true);
              }
            );
            this.subscriptions.add(idTokenSubscription);
          } else {
            this.customToasters.customError(EidErrors.userNotAuthenticatedError);
            this.routeHelper.login(true);
          }
        },
        (error) => {
          // isAuthenticated subscription fails
          this.customToasters.customError(EidErrors.isAuthenticatedsubscriptionFails + ' : ' + error);
          this.routeHelper.login(true);
        }
      )
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private exchangeToken(idToken: string): void {
    const accessTokenSubscription = this.eidAuthService.accessToken.subscribe((token) => {
      this.eidAuthService.setToken(token);
    });
    this.subscriptions.add(accessTokenSubscription);

    this.subscriptions.add(
      this.authService.loginEid(idToken).subscribe(
        async () => {
          let redirectUrl = sessionStorage.getItem('redirectURL');
          if (!redirectUrl) {
            redirectUrl = null;
          }
          this.redirectService.handleLogin(redirectUrl);
          sessionStorage.removeItem('redirectURL');
          await this.eidSessionService.handleSession();
        },
        () => {
          this.routeHelper.login(true);
        }
      )
    );
  }
}
